import { SVGProps } from "react";

type Bitrix24IconProps = SVGProps<SVGSVGElement> & { size?: number | string };

export const Bitrix24Icon = ({ size = 24, ...props }: Bitrix24IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill="url(#a)"
      fillRule="evenodd"
      d="M17.103 6.788a7.634 7.634 0 0 0-13.5 5.554 8.014 8.014 0 0 0 3.84 14.64v.023h.5a8.037 8.037 0 0 0 .26 0h16.304l.16.002a7.256 7.256 0 0 0 2.303-14.138 7.256 7.256 0 0 0-9.867-6.081Z"
      clipRule="evenodd"
    />
    <path
      fill="#0075FF"
      fillRule="evenodd"
      d="M17.103 6.788a7.634 7.634 0 0 0-13.5 5.554 8.014 8.014 0 0 0 3.84 14.64v.023h.5a8.037 8.037 0 0 0 .26 0h16.304l.16.002a7.256 7.256 0 0 0 2.303-14.138 7.256 7.256 0 0 0-9.867-6.081Z"
      clipRule="evenodd"
    />
    <path
      fill="url(#b)"
      fillRule="evenodd"
      d="M11.384 12.78c.836 0 1.62.334 1.62 1.283 0 .854-.78 1.42-1.754 2.126-1.492 1.082-3.435 2.49-3.708 5.764h8.002v-1.93h-5.029c.305-1.005 1.264-1.733 2.252-2.484 1.288-.978 2.626-1.995 2.626-3.71 0-1.73-1.186-2.963-3.641-2.963-1.57 0-2.89.483-3.843.916l.585 1.748c.852-.383 1.771-.75 2.89-.75Zm8.683 4.728h-1.003c-.384 0-1.186.033-1.386.05l2.489-3.28c-.034.217-.1 1.2-.1 2.048v1.182Zm.584-6.609-5.512 6.992v1.448h4.928v2.614h2.222v-2.614h1.637v-1.83h-1.637v-6.61H20.65Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillOpacity=".93"
      fillRule="evenodd"
      d="M11.384 12.78c.836 0 1.62.334 1.62 1.283 0 .854-.78 1.42-1.754 2.126-1.492 1.082-3.435 2.49-3.708 5.764h8.002v-1.93h-5.029c.305-1.005 1.264-1.733 2.252-2.484 1.288-.978 2.626-1.995 2.626-3.71 0-1.73-1.186-2.963-3.641-2.963-1.57 0-2.89.483-3.843.916l.585 1.748c.852-.383 1.771-.75 2.89-.75Zm8.683 4.728h-1.003c-.384 0-1.186.033-1.386.05l2.489-3.28c-.034.217-.1 1.2-.1 2.048v1.182Zm.584-6.609-5.512 6.992v1.448h4.928v2.614h2.222v-2.614h1.637v-1.83h-1.637v-6.61H20.65Z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="a"
        x1="-3.139"
        x2="-3.392"
        y1="-5.528"
        y2="31.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CBFF14" />
        <stop offset=".242" stop-color="#33F45B" />
        <stop offset=".735" stop-color="#0075FF" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="7.542"
        x2="7.542"
        y1="10.866"
        y2="21.953"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#21C9C2" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
    </defs>
  </svg>
);
